import React, { useEffect } from "react";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Box,
  Button,
  Grid,
  MenuItem,
  TextField,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getRoles, createRole } from "redux/actions";
import { AxiosResponse } from "axios";

const RoleCreate = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getRoles());
  }, [dispatch]);

  const validationSchema = Yup.object().shape({
    role: Yup.string().required("Role is required"),
    moduleType: Yup.string().required("ModuleType is required"),
    status: Yup.string().oneOf(["true", "false"]).required("Status is required"),
  });

  const handleSubmit = async (values: any) => {
    const dataPayload = {
      role: values.role,
      moduleType: values.moduleType,
      isActive: values.status === "true" ? 1 : 0,
    };

    try {
      const response = (await dispatch(createRole(dataPayload))) as unknown as AxiosResponse;
      if (response.status === 200) {
        navigate(`/master/manageRole`);
      }
    } catch (error) {
      console.error("Error creating role:", error);
    }
  };

  return (
    <Box sx={{ height: "100%", width: "100%", m: 8 }}>
      <Grid container direction="column" spacing={3} m={2}>
        <Formik
          initialValues={{
            role: "",
            moduleType: "",
            status: "true",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ touched, errors }) => (
            <Form>
              <Grid container spacing={3} mb={3}>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Role"
                    name="role"
                    variant="outlined"
                    error={touched.role && !!errors.role}
                    helperText={<ErrorMessage name="role" />}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Field
                    as={TextField}
                    fullWidth
                    label="Module Type"
                    name="moduleType"
                    variant="outlined"
                    error={touched.moduleType && !!errors.moduleType}
                    helperText={<ErrorMessage name="moduleType" />}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={3} mb={3}>
                <Grid item xs={6}>
                  <Field name="status">
                    {({ field }: any) => (
                      <TextField
                        {...field}
                        select
                        fullWidth
                        label="Status"
                        variant="outlined"
                        error={touched.status && !!errors.status}
                        helperText={<ErrorMessage name="status" />}
                      >
                        <MenuItem value="true">Active</MenuItem>
                        <MenuItem value="false">Inactive</MenuItem>
                      </TextField>
                    )}
                  </Field>
                </Grid>
              </Grid>

              <Box
                sx={{
                  position: "fixed",
                  bottom: 0,
                  left: 0,
                  width: "100%",
                  display: "flex",
                  justifyContent: "flex-end",
                  gap: 2,
                  py: 2,
                  px: 4,
                  zIndex: 1000,
                  backgroundColor: "white",
                  boxShadow: "0 -2px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Button
                  variant="outlined"
                  onClick={() => navigate("/master/manageRole/roles")}
                >
                  Cancel
                </Button>
                <Button type="submit" variant="contained" color="primary">
                  Add Role
                </Button>
              </Box>
            </Form>
          )}
        </Formik>
      </Grid>
    </Box>
  );
};

export default RoleCreate;
